var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 9.99999C10.8334 10.4602 10.4603 10.8333 10.0001 10.8333C9.53984 10.8333 9.16675 10.4602 9.16675 9.99999C9.16675 9.53975 9.53984 9.16666 10.0001 9.16666C10.4603 9.16666 10.8334 9.53975 10.8334 9.99999Z",
    stroke: "#808897",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83341 9.99999C5.83341 10.4602 5.46032 10.8333 5.00008 10.8333C4.53984 10.8333 4.16675 10.4602 4.16675 9.99999C4.16675 9.53975 4.53984 9.16666 5.00008 9.16666C5.46032 9.16666 5.83341 9.53975 5.83341 9.99999Z",
    stroke: "#808897",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 9.99999C15.8334 10.4602 15.4603 10.8333 15.0001 10.8333C14.5398 10.8333 14.1667 10.4602 14.1667 9.99999C14.1667 9.53975 14.5398 9.16666 15.0001 9.16666C15.4603 9.16666 15.8334 9.53975 15.8334 9.99999Z",
    stroke: "#808897",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsHorizontal);
export default __webpack_public_path__ + "static/media/dots-horizontal.a1e5edc9a392b1cfa7b78ebe85e7e062.svg";
export { ForwardRef as ReactComponent };